export default class StorageService {

  /**
   * Identifier appended to non-string values when stringified for storage.
   * This is so the value can be identified to be parsed to it's original type in the get method.
   */
  static #indentifyAsJson = '::isJSON';

  /** Set to sessionStorage or localStorage in save method. */
  static #storage;

  /** @ignore */
  constructor() {}

  /**
   * Save any item (value) to localStorage or sessionStorage
   * @param key {string} name of item to be saved
   * @param value item to be saved
   * @param session {boolean} save to sessionStorage if true; else save to localStorage
   * @return {StorageService}
   */
  static save(key, value, session = false) {
    this.#storage = session ? sessionStorage : localStorage;
    if (typeof value !== 'string') value = JSON.stringify(value) + this.#indentifyAsJson;
    if (value !== undefined || value !== null) this.#storage[key] = value;
    return this;
  }

  /**
   * Get item from localStorage or sessionStorage as it's original type and value
   * @param key {string} name of item to be retrieved
   * @return {any}
   */
  static get(key) {
    let val = localStorage[key] || sessionStorage[key];
    if (val && val.endsWith(this.#indentifyAsJson)) val = JSON.parse(val.replace(this.#indentifyAsJson, ''));
    return val;
  }

  /**
   * Delete item from localStorage and sessionStorage
   * @param key {string} name of item to be deleted
   * @return {StorageService}
   */
  static remove(key) {
    localStorage.removeItem(key);
    sessionStorage.removeItem(key);
    return this;
  }

  /**
   * Delete all items from localStorage, sessionStorage, or both.
   * @param local {boolean} default true, if true clear localStorage
   * @param session {boolean} default true, if true clear sessionStorage
   * @return {StorageService}
   */
  static clear(local = true, session = true) {
    if (local) localStorage.clear();
    if (session) sessionStorage.clear();
    return this;
  }
}